"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutRedirectHandler = void 0;
exports.handleCheckoutValidationAndRedirect = handleCheckoutValidationAndRedirect;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _bwaLoader = _interopRequireDefault(require("../components/bwa-loader/bwa-loader"));
var _utils = require("./utils");
var _urlSafety = require("./url-safety");
var _bwaEmptyWidget = _interopRequireDefault(require("../components/bwa-empty-widget/bwa-empty-widget"));
var _constants = require("../constants/constants");
function handleCheckoutValidationAndRedirect(_x, _x2) {
  return _handleCheckoutValidationAndRedirect.apply(this, arguments);
}
function _handleCheckoutValidationAndRedirect() {
  _handleCheckoutValidationAndRedirect = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(checkoutId, redirectUrl) {
    var loader, isMeta, isMShopFlow, widget, isAddressSaved;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          loader = new _bwaLoader["default"]();
          isMeta = (0, _utils.isMetaBrowser)();
          isMShopFlow = sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.IS_MSHOP_INSTALLED) === "true";
          widget = new _bwaEmptyWidget["default"]();
          if (isMShopFlow) {
            _context2.next = 7;
            break;
          }
          _context2.next = 7;
          return widget.ready;
        case 7:
          _context2.next = 9;
          return widget.validateCheckoutV3(checkoutId);
        case 9:
          isAddressSaved = _context2.sent;
          if (isMeta) {
            loader.updateLoaderForMeta(isAddressSaved, redirectUrl);
          } else {
            loader.dismiss();
            (0, _urlSafety.safeRedirect)(redirectUrl);
          }
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _handleCheckoutValidationAndRedirect.apply(this, arguments);
}
var CheckoutRedirectHandler = exports.CheckoutRedirectHandler = /*#__PURE__*/function () {
  function CheckoutRedirectHandler() {
    (0, _classCallCheck2["default"])(this, CheckoutRedirectHandler);
  }
  return (0, _createClass2["default"])(CheckoutRedirectHandler, null, [{
    key: "setupMessageListener",
    value: function setupMessageListener(config) {
      window.addEventListener(_constants.EVENT_TYPE.MESSAGE, /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
          var _event$data, _event$data4, lastClickedButton, _event$data2, _event$data3, cartDetails, extraFields, message;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                lastClickedButton = sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.LAST_CLICKED_BUTTON_TYPE);
                if (!(lastClickedButton !== config.expectedButtonType)) {
                  _context.next = 5;
                  break;
                }
                console.debug("[BwA] Skipping message handler \u2014 last clicked button is not ".concat(config.buttonName, "."));
                return _context.abrupt("return");
              case 5:
                if (!(((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.type) === _constants.EVENT_TYPE.CUSTOM.CHECKOUT_BUTTON_CLICKED)) {
                  _context.next = 15;
                  break;
                }
                window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_CHECKOUT_BUTTON_SUBMIT, {
                  detail: {
                    mode: ((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.buttonId) === config.checkoutButtonWithAddressPrefillId ? "ADDRESS_SELECTION" : "WITHOUT_ADDRESS_SELECTION"
                  }
                }));
                _context.next = 9;
                return config.getCartDetails();
              case 9:
                cartDetails = _context.sent;
                extraFields = {
                  buttonId: (_event$data3 = event.data) === null || _event$data3 === void 0 ? void 0 : _event$data3.buttonId
                };
                message = (0, _utils.buildCheckoutMessage)({
                  cartDetails: cartDetails,
                  storeUrl: config.storeUrl,
                  storeId: config.storeId,
                  ecp: _constants.ECP,
                  extraFields: extraFields
                });
                config.bwaCheckoutButtonIframeIds.forEach(function (iframeId) {
                  (0, _utils.postMessageToIframe)(iframeId, message);
                });
                _context.next = 16;
                break;
              case 15:
                if (((_event$data4 = event.data) === null || _event$data4 === void 0 ? void 0 : _event$data4.type) === _constants.EVENT_TYPE.CUSTOM.BWA_ADDRESS_CHECKOUT_SELECTION_DIALOG_CLOSED) {
                  config.hideCheckoutAddressSelectionDialog();
                }
              case 16:
                _context.next = 21;
                break;
              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](0);
                console.error('[BwA] Error handling message event:', _context.t0);
              case 21:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 18]]);
        }));
        return function (_x3) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }]);
}();
//# sourceMappingURL=checkout-redirect-handler.js.map
